import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import ReactHtmlParser from "react-html-parser";
import { change } from "redux-form";

// import { EditorState, convertToRaw, ContentState } from 'draft-js';
// import { Editor } from 'react-draft-wysiwyg';
// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import * as validFunc from "libs/validation";

import { Image, Popup, Label, Button } from "semantic-ui-react";
import {
  ReduxFormHiddenRecord,
  ReduxFormMaterialTextField,
  ReduxFormMaterialSelect,
  Loading,
  CustomEditor,
} from "components";
import * as commonVar from "libs/commonVar";
import classNames from "classnames/bind";
import styles from "./ExamTemplateEdit.css";

const cx = classNames.bind(styles);

class ExamTemplateEdit extends PureComponent {
  constructor(props) {
    super(props);

    const {
      templateInfo: { body, attachScreenContent },
    } = props;

    let stateObj = {
      convertHtml: "",
      screenHtml: "",
      // convertHtmlPreview: '',
      // screenHtmlPreview: ''
    };
    // let editorState = EditorState.createEmpty();
    // let screenState = EditorState.createEmpty();

    if (body) {
      stateObj.convertHtml = body;
      // stateObj.convertHtmlPreview = body;
      // const contentBlock = htmlToDraft(body);
      // if (contentBlock) {
      //   const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      //   editorState = EditorState.createWithContent(contentState);
      // }
    }
    if (attachScreenContent) {
      stateObj.screenHtml = attachScreenContent;
      // stateObj.screenHtmlPreview = attachScreenContent;
      // const contentBlock = htmlToDraft(attachScreenContent);
      // if (contentBlock) {
      //   const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      //   screenState = EditorState.createWithContent(contentState);
      // }
    }

    stateObj = {
      ...stateObj,
      // editorState,
      // screenState,
      phishingList: [],
      phishingArray: [],
      // editorPaste: false,
      // screenPaste: false,
      bodyDisable: true,
      resultDisable: true,
    };

    this.state = stateObj;

    // 원본파일명의 확장자 체크
    this.warnAttachCompress = "";

    // let optionArray = ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'];
    // if (localStorage.getItem('language') === 'ko') {
    //   optionArray = [
    //     'Arial',
    //     'Georgia',
    //     'Impact',
    //     'Tahoma',
    //     'Times New Roman',
    //     'Verdana',
    //     'Malgun Gothic',
    //     'Gulim',
    //     'Dotum',
    //     'Batang',
    //     'Gungsuh'
    //   ];
    // }

    // this.toolbarOptions = {
    //   options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'remove', 'colorPicker', 'textAlign', 'image'],
    //   inline: {
    //     options: ['bold', 'italic', 'underline', 'strikethrough']
    //   },
    //   fontFamily: {
    //     options: optionArray
    //   },
    //   colorPicker: {
    //     icon: null,
    //     className: 'color-select-icon',
    //     popupClassName: 'color-select-popup'
    //   },
    //   image: {
    //     icon: null,
    //     className: 'image-attach-icon',
    //     popupClassName: 'image-attach-popup',
    //     uploadEnabled: true,
    //     uploadCallback: props.uploadBodyImage
    //   }
    // };

    let ELanguage =
      localStorage.getItem("language") === "ko"
        ? "ko-KR"
        : localStorage.getItem("language") === "ja"
        ? "ja-JP"
        : "en-US";
    let fonts = [
      "Arial",
      "Georgia",
      "Times New Roman",
      "Verdana",
      "Malgun Gothic",
    ];
    fonts = ELanguage === "ja-JP" ? [...fonts, "MEIRYO"] : fonts;
    this.summernoteOptions = {
      height: 400,
      lang: ELanguage,
      dialogsInBody: true,
      disableDragAndDrop: true,
      codeviewFilter: true,
      fontNamesIgnoreCheck: fonts,
      fontNames: fonts,
      styleTags: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
      toolbar: [
        ["font", ["bold", "italic", "underline", "strikethrough", "clear"]],
        ["fontsize", ["fontsize"]],
        ["fontname", ["fontname"]],
        ["style", ["style"]],
        ["color", ["color"]],
        ["para", ["paragraph"]],
        ["insert", ["hr"]],
        ["view", ["codeview"]],
      ],
    };
  }

  componentDidMount() {
    const { templatePhishing } = this.props;
    let phishingInfo = {}; // 선택한 피싱 템플릿 정보
    let phishingArr = [];
    const phishingList = []; // 피싱 유도 설정에 보여줄 목록

    phishingArr = templatePhishing.toJS();

    if (phishingArr && phishingArr.length > 0) {
      phishingArr.map((item, index) => {
        let phishingObj = {
          key: item.phishingNo,
          value: item.phishingNo,
          text: item.phishingName,
        };

        if (
          this.props.templateInfo.examType === 4 &&
          item.phishingNo === this.props.templateInfo.phishingNo
        ) {
          phishingInfo = item;
          phishingList.unshift(phishingObj);
        }

        if (item.isPublic === 1) {
          if (phishingList.indexOf(phishingObj) < 0) {
            phishingList.push(phishingObj);
          }
        }
      });
    }

    if (phishingInfo) {
      this.codeResultUrl({
        html: phishingInfo.phishingMailbody,
        css: null,
        js: null,
        target: "body",
      });
      this.codeResultUrl({
        html: phishingInfo.phishingHtml3,
        css: phishingInfo.phishingCss3,
        js: phishingInfo.phishingJs3,
        target: "result",
      });
    }

    this.setState({
      phishingList: phishingList,
      phishingArray: phishingArr ? phishingArr : [],
      phishingScreenEnable: phishingInfo
        ? phishingInfo.phishingScreenEnable
        : 0,
    });

    // 모달의 onOpen 이벤트 대용
    const { handleOnOpenEditModal } = this.props;
    handleOnOpenEditModal();
  }

  componentDidUpdate(prevProps, prevState) {
    const { formStore } = this.props;
    const {
      phishingArray,
      fileValue,
      editorPaste,
      screenPaste,
      editorState,
      screenState,
    } = this.state;

    if (fileValue !== prevState.fileValue) {
      document.getElementById("select-file-name").value = fileValue;
      if (document.getElementById("select-file-name-result")) {
        document.getElementById("select-file-name-result").value = fileValue;
      }
    }

    // 피싱 유도 설정에서 선택 목록 변경 시 해당 메일 본문 넣어줌
    if (
      phishingArray &&
      (prevProps.formStore && prevProps.formStore.values.phishingNo) !==
        (formStore && formStore.values.phishingNo)
    ) {
      let phishingInfo = {};
      this.state.phishingArray.map((item) => {
        if (
          this.props.formStore.values.examType === 4 &&
          item.phishingNo === this.props.formStore.values.phishingNo
        ) {
          phishingInfo = item;
        }
      });

      if (phishingInfo) {
        this.codeResultUrl({
          html: phishingInfo.phishingMailbody,
          css: null,
          js: null,
          target: "body",
        });
        this.codeResultUrl({
          html: phishingInfo.phishingHtml3,
          css: phishingInfo.phishingCss3,
          js: phishingInfo.phishingJs3,
          target: "result",
        });
      }

      this.setState({
        ...this.state,
        phishingScreenEnable: phishingInfo
          ? phishingInfo.phishingScreenEnable
          : 0,
      });
    }

    // 붙여넣기 시 에디터 업데이트
    if (prevState.editorPaste !== editorPaste) {
      // 메일 본문
      this.handleOnEditorStateChange(editorState);
    } else if (prevState.screenPaste !== screenPaste) {
      // 잠금 화면
      this.handleOnScreenEditorStateChange(screenState);
    }
  }

  onToggleSelected(data) {
    const { dispatch, formStore } = this.props;

    // 훈련 유형을 선택했는데, 다운로드 유형을 선택 안했을 경우 / 링크 첨부를 기본 선택
    if (
      data.name === "examType" &&
      data.value === 1 &&
      formStore.values.linkAttach === 0
    ) {
      dispatch(change("examTemplateEdit", "linkAttach", 2));
    }
    // 훈련 유형을 선택했는데, 첨부유형을 선택 안했을 경우 / 압축파일을 기본 선택
    if (
      data.name === "examType" &&
      data.value === 1 &&
      formStore.values.attachType === 0
    ) {
      dispatch(change("examTemplateEdit", "attachType", 2));
    }
    // 다운로드 유형을 선택했는데, 첨부유형을 선택 안했을 경우 / 압축파일을 기본 선택
    if (
      data.name === "linkAttach" &&
      data.value > 0 &&
      formStore.values.attachType === 0
    ) {
      dispatch(change("examTemplateEdit", "attachType", 2));
    }

    dispatch(change("examTemplateEdit", data.name, data.value));
  }

  // 첨부파일 변경시
  onChangeAttachInfoNo = (value) => {
    if (value > 0) {
      const { dispatch, formStore, checkFileExt } = this.props;
      // 다운로드 유형을 선택 안했을 경우 / 링크 첨부를 기본 선택
      if (formStore.values.linkAttach === 0) {
        dispatch(change("examTemplateEdit", "linkAttach", 2));
      }
      // 첨부유형을 선택 안했을 경우 / 압축파일을 기본 선택
      if (formStore.values.attachType === 0) {
        dispatch(change("examTemplateEdit", "attachType", 2));
      }

      const { attachData, attachIndexList } = this.props;
      const aData = attachData.get(String(attachIndexList.get(String(value))));

      // lnk 파일 선택시 원본은 안됨 (압축 파일 선택으로 변경)
      if (aData.get("fileExt") === "lnk" && formStore.values.attachType < 2) {
        dispatch(change("examTemplateEdit", "attachType", 2));
      }

      if (checkFileExt()) {
        dispatch(
          change(
            "examTemplateEdit",
            "attachName",
            formStore.values.attachName + " "
          )
        );
      }
    }
  };

  // 압축파일명, 압축 파일 확장자 변경시
  onChangeAttachCompress = () => {
    this.checkAttachCompress();
  };

  //
  checkAttachCompress = () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { formStore, attachData, attachIndexList } = this.props;
    let attachInfoNo = -1;
    if (formStore.values.attachInfoNo) {
      attachInfoNo = formStore.values.attachInfoNo;
    }
    const aData = attachData.get(
      String(attachIndexList.get(String(attachInfoNo)))
    );
    let attachValue = null;
    if (aData) {
      attachValue = aData.toJS();
    }

    // 만약 validate에 에러가 발생하면 warnning은 표시 안함
    if (
      attachValue &&
      !!formStore.syncErrors &&
      !!formStore.syncErrors.attachCompressName
    ) {
      this.warnAttachCompress = "";
    } else {
      const attachName = formStore.values.attachCompressName;

      // zip, 7z확장자 체크
      if (!!validFunc.extensionAttachCompress(attachName)) {
        this.warnAttachCompress = validFunc.extensionAttachCompress(attachName);
        // 첨부파일의 확장자와 압축 파일 종류가 다를경우
      } else if (
        (formStore.values.attachCompress === 1 &&
          validFunc.RegExpZip.test(attachName)) ||
        (formStore.values.attachCompress === 2 &&
          validFunc.RegExp7z.test(attachName))
      ) {
        this.warnAttachCompress = defineMessages(
          formatMessage({
            id: "ExamTemplateEdit_38",
            defaultMessage: "첨부파일의 확장자와 압축 파일 종류가 다릅니다.",
          })
        );
      } else {
        this.warnAttachCompress = "";
      }
    }
  };

  // 붙여넣기 이벤트
  // handlePastedText = async type => {
  //   if (type === 'editor') { // 메일 본문
  //     this.setState({
  //       editorPaste: true
  //     });
  //   } else { // 잠금 화면
  //     this.setState({
  //       screenPaste: true
  //     });
  //   }

  //   return true;
  // };

  // 이미지 정렬 설정
  // setAlign = htmlState => {
  //   const pEl = document.createElement('p');
  //   pEl.innerHTML = this.convertEditStateToHtml(htmlState);
  //   const htmlObject = pEl;
  //   const imgArray = Array.from(htmlObject.getElementsByTagName('img'));
  //   let editor = htmlState;

  //   imgArray.map((item, index) => {
  //     const div = document.createElement('div');
  //     div.classList.add('float-clear');
  //     div.style.cssText = div.style.cssText + 'display:block;clear:both;height:1px;';
  //     item.after(div);

  //     if (item.style.float) {
  //       if (item.style.float === 'left') {
  //         imgArray[index].style.cssText = item.style.cssText + 'display:block;margin:0 auto 0 0';
  //       } else if (item.style.float === 'none') {
  //         imgArray[index].style.cssText = item.style.cssText + 'display:block;margin:0 auto';
  //       } else if (item.style.float === 'right') {
  //         imgArray[index].style.cssText = item.style.cssText + 'display:block;margin:0 0 0 auto';
  //       }
  //     }
  //   });

  //   // 붙여넣기 했을 시 editorState 변경
  //   const contentBlock = htmlToDraft(htmlObject.outerHTML.replace(new RegExp("<p></p>", "g"), '<p>&nbsp;</p>').replace(new RegExp("\udcf7", "g"), ''));
  //   const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
  //   if (this.state.editorPaste) {
  //     editor = EditorState.createWithContent(contentState);
  //     this.setState({
  //       editorPaste: false
  //     });
  //   } else if (this.state.screenPaste) {
  //     editor = EditorState.createWithContent(contentState);
  //     this.setState({
  //       screenPaste: false
  //     });
  //   }

  //   return {
  //     editor: editor,
  //     html: htmlObject.outerHTML.replace(new RegExp("<p></p>", "g"), '<p>&nbsp;</p>').replace(new RegExp("\udcf7", "g"), '')
  //   };
  // };

  // 메일 본문 입력
  // handleOnEditorStateChange = editorState => {
  //   // this.setState({ editorState, convertHtml: this.convertEditStateToHtml(this.state.editorState) });
  //   const result = this.setAlign(editorState);
  //   this.setState({ editorState: result.editor, convertHtml: result.html });
  // };

  // 악성파일 잠금 화면 내용 입력
  // handleOnScreenEditorStateChange = screenState => {
  //   // this.setState({ screenState, screenHtml: this.convertEditStateToHtml(this.state.screenState) });
  //   const result = this.setAlign(screenState);
  //   this.setState({ screenState: result.editor, screenHtml: result.html });
  // };

  // convertEditStateToHtml = editorState => {
  //   return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  // };

  // 피싱 메일 본문 및 결과 화면 코드 iframe에 삽입
  codeResultUrl = ({ html, css, js, target }) => {
    const parseCode = (code) => {
      if (code) {
        const date = new Date();
        const month = date.getMonth();
        const doubleDigitMonth = month < 10 ? "0" + month : month;

        return code
          .replace(/\$\{SERVER_ROOT\}\$/g, window.location.origin)
          .replace(/\$\{DATE_YM\}\$/g, date.getFullYear() + doubleDigitMonth);
      } else {
        return "";
      }
    };

    const parsedHTML = parseCode(html);
    const parsedCSS = parseCode(css);
    const parsedJS = parseCode(js);
    const source = `
      <html>
        <head>
          <style>${parsedCSS}</style>
        </head>
        <body>
          ${parsedHTML}
          <script src="${window.location.origin}/certification/jquery/jquery-1.10.2.min.js"></script>
          <script>${parsedJS}</script>
        </body>
      </html>
    `;

    if (document.getElementById(`phishing-${target}-iframe`)) {
      var iframeDoc = document.getElementById(`phishing-${target}-iframe`)
        .contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(source);
      iframeDoc.close();
    }
  };

  // 이미지 업로드 이벤트
  onImageUploadEditor = (fileList, insertImage) => {
    const file = fileList[0];
    const extension = file.name
      .substring(file.name.lastIndexOf(".") + 1)
      .toLowerCase();
    // bmp, jpg, jpeg, png, gif 확장자를 가진 파일만 업로드
    if (extension.match(/bmp|jpg|jpeg|png|gif/)) {
      this.props.uploadBodyImage(file).then((response) => {
        if (response.data) {
          insertImage(response.data.link);
        }
      });
    }
  };

  // 에디터 내용 변경 이벤트
  onChangeEditor = (contents, target) => {
    const parsedHTML = contents.replace(
      /\$\{SERVER_ROOT\}\$/g,
      window.location.origin
    );
    this.setState({
      [target]: parsedHTML,
    });
  };

  // 에디터 영역 클릭 시 에디터의 메뉴바 활성화
  onFocusEditor = (target) => {
    if (target === "convertHtml") {
      this.setState({
        bodyDisable: false,
      });
    } else {
      this.setState({
        resultDisable: false,
      });
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // const { editorState, screenState, convertHtml, screenHtml, phishingScreenEnable } = this.state;
    const {
      convertHtml,
      screenHtml,
      phishingScreenEnable,
      bodyDisable,
      resultDisable,
    } = this.state;
    const {
      isAuth,
      formStore,
      onProgress,
      templateInfo,
      attachData,
      attachIndexList,
      checkFileExt,
    } = this.props;
    // const { handleOnEditorStateChange, handleOnScreenEditorStateChange } = this;
    const {
      onChangeAttachCompress,
      checkAttachCompress,
      onChangeAttachInfoNo,
    } = this;

    const { serviceTemplateNo } = templateInfo;

    let AttachInfo;
    let attachType = -1;
    let linkAttach = -1;
    let examType = -1;
    let phishingNo = -1;
    let attachScreenType = -1;
    let attachInfoNo = -1;
    let templatePublic = -1;
    let screenEnable = -1;
    // let nisDeclareEnable = -1;
    // let nisDeclareCode = '';

    if (formStore && formStore.values) {
      if (formStore.values.attachType) {
        attachType = formStore.values.attachType;
      }
      if (formStore.values.linkAttach) {
        linkAttach = formStore.values.linkAttach;
      }
      if (formStore.values.examType) {
        examType = formStore.values.examType;
      }
      if (formStore.values.attachScreenType) {
        attachScreenType = formStore.values.attachScreenType;
      }
      if (formStore.values.examType === 4 && formStore.values.phishingNo) {
        phishingNo = formStore.values.phishingNo;
      }
      if (formStore.values.attachInfoNo) {
        attachInfoNo = formStore.values.attachInfoNo;
      }
      if (
        formStore.values.templatePublic === 1 ||
        formStore.values.templatePublic === 0
      ) {
        templatePublic = formStore.values.templatePublic;
      }
      if (
        formStore.values.screenEnable === 1 ||
        formStore.values.screenEnable === 0
      ) {
        screenEnable = formStore.values.screenEnable;
      }

      // 국정원 신고 하기
      // if (formStore.values.nisDeclareEnable === 1 || formStore.values.nisDeclareEnable === 0) {
      //   nisDeclareEnable = formStore.values.nisDeclareEnable;
      // }
      // if (formStore.values.nisDeclareCode) {
      //   nisDeclareCode = formStore.values.nisDeclareCode;
      // }

      checkAttachCompress();
    }

    // 첨부파일 정보
    const aData = attachData.get(
      String(attachIndexList.get(String(attachInfoNo)))
    );
    let attachValue = null;
    if (aData) {
      attachValue = aData.toJS();
    }

    let attachTypeLable = defineMessages(
      formatMessage({
        id: "ExamTemplateEdit_26",
        defaultMessage:
          "원본파일명 (메일에 첨부되는 파일 이름을 지정할 수 있습니다.)",
      })
    );
    if (attachType > 1) {
      attachTypeLable = defineMessages(
        formatMessage({
          id: "ExamTemplateEdit_25",
          defaultMessage:
            "원본파일명 (메일에 첨부되는 압축파일 안의 파일 이름을 지정할 수 있습니다.)",
        })
      );
    }

    // 첨부 파일로 다운로드
    if (attachValue) {
      if (linkAttach === 1) {
        if (commonVar.isJapan !== 1) {
          // 원본, 압축 파일, 비밀번호 압축
          if (
            attachType > 0 &&
            (attachType === 1 || attachType === 2 || attachType === 3)
          ) {
            AttachInfo = (
              <div className={cx("font-size-13 color-dark-red mt-4")}>
                <div>
                  {"- " +
                    defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_43",
                        defaultMessage: "해당 메일로는 파일 첨부 불가",
                      })
                    )}
                  {attachType === 3 ? ": Google" : ": Google, Naver"}
                </div>
              </div>
            );
          }
        }
      }
    }

    const examTypeList = [
      {
        key: 2,
        value: 1,
        text: defineMessages(
          formatMessage({
            id: "ExamTemplateEdit_70",
            defaultMessage: "첨부 파일 (경고안내, 모의악성파일, 실태조사)",
          })
        ),
      },
      {
        key: 3,
        value: 4,
        text: defineMessages(
          formatMessage({
            id: "ExamTemplateEdit_31",
            defaultMessage:
              "피싱 유도 (피싱 페이지 - 피싱 유도 링크가 메일에 삽입되어 대상자가 정보를 입력하는 형태의 훈련입니다.)",
          })
        ),
      },
    ];

    const attachOptions = [];
    const attachD = attachData.toJS();
    if (attachD && Array.isArray(attachD)) {
      for (let i = 0, l = attachD.length; i < l; i++) {
        const attachInfo = attachD[i];

        // 삭제된 항목은 제거
        // if (attachInfo.isEnable !== 1) {
        //   continue;
        // }

        // 구분(기본,사용자)
        const isBasic = (
          <div className={cx("temp-examType-box", "attach-basic")}>
            {attachInfo.isBasic === 1 ? (
              <Label
                basic
                size="small"
                className={cx("template-type-label color-temp-system")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateList_2",
                    defaultMessage: "기 본",
                  })
                )}
              </Label>
            ) : (
              <Label
                basic
                size="small"
                className={cx("template-type-label color-temp-user")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateList_3",
                    defaultMessage: "사용자",
                  })
                )}
              </Label>
            )}
          </div>
        );

        // 템플릿 실행 결과
        const attachExamType =
          (attachInfo.attachExamType === 1 && (
            <div className={cx("temp-examType-box", "temp-examType-right")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-temp-warning")}
              >
                {defineMessages(
                  formatMessage({
                    id: "StartExamWizardContent_95",
                    defaultMessage: "경고 안내",
                  })
                )}
              </Label>
            </div>
          )) ||
          (attachInfo.attachExamType === 2 && (
            <div className={cx("temp-examType-box", "temp-examType-right")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-temp-file")}
              >
                {defineMessages(
                  formatMessage({
                    id: "StartExamWizardContent_88",
                    defaultMessage: "모의 악성파일",
                  })
                )}
              </Label>
            </div>
          )) ||
          (attachInfo.attachExamType === 3 && (
            <div className={cx("temp-examType-box", "temp-examType-right")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-temp-research")}
              >
                {defineMessages(
                  formatMessage({
                    id: "StartExamWizardContent_89",
                    defaultMessage: "실태 조사",
                  })
                )}
              </Label>
            </div>
          ));

        const attachCategory =
          (attachInfo.attachCategory === 1 && (
            <div className={cx("temp-examType-box", "temp-examType-left")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-attach-exe")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamAttachCategory_1",
                    defaultMessage: "실행파일",
                  })
                )}
              </Label>
            </div>
          )) ||
          (attachInfo.attachCategory === 2 && (
            <div className={cx("temp-examType-box", "temp-examType-left")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-attach-lnk")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamAttachCategory_2",
                    defaultMessage: "바로가기",
                  })
                )}
              </Label>
            </div>
          )) ||
          (attachInfo.attachCategory === 3 && (
            <div className={cx("temp-examType-box", "temp-examType-left")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-attach-doc")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamAttachCategory_3",
                    defaultMessage: "문서파일",
                  })
                )}
              </Label>
            </div>
          )) ||
          (attachInfo.attachCategory === 4 && (
            <div className={cx("temp-examType-box", "temp-examType-left")}>
              <Label
                basic
                size="small"
                className={cx("temp-examType color-attach-html")}
              >
                {defineMessages(
                  formatMessage({
                    id: "ExamAttachCategory_4",
                    defaultMessage: "웹문서",
                  })
                )}
              </Label>
            </div>
          ));

        const FileIconComponent = (
          <Image
            className={cx("file-icon-image")}
            src={
              "/fdata/attachFile/" +
              attachInfo.attachInfoNo +
              "/" +
              attachInfo.fileIcon
            }
          />
        );
        const FileExtComponent = (
          <div>
            <div className={cx("file-ext")}>{attachInfo.fileExt}</div>
          </div>
        );

        const attachFuncKey = Object.keys(
          JSON.parse(attachInfo.attachFunction)
        );
        const attachFunction = attachFuncKey.map((keys, i) => {
          return (
            <Label
              key={i}
              basic
              size="small"
              className={cx("template-type-label color-bg-attachFunction")}
            >
              {keys}
            </Label>
          );
        });

        const attachResKey = Object.keys(JSON.parse(attachInfo.attachRestrict));
        const attachRestrict = attachResKey.map((keys, i) => {
          return (
            <Label
              key={i}
              basic
              size="small"
              className={cx("template-type-label color-bg-attachRestrict")}
            >
              {keys}
            </Label>
          );
        });

        const attachSubject = (
          <div className={cx("attach-subject")}>{attachInfo.attachSubject}</div>
        );
        const renderTitle = (
          <div
            className={cx(
              "attach-input",
              !!!serviceTemplateNo && isAuth !== 2 && "disabled"
            )}
          >
            <div className={cx("attach-info-no")}>
              {attachInfo.attachInfoNo}
            </div>
            {/* 파일 아이콘 */}
            {FileIconComponent}
            <div className={cx("render-title")}>
              {/* 구분 */}
              {isBasic}
              {/* 첨부 유형 */}
              {attachCategory}
              {/* 훈련 유형 */}
              {attachExamType}
              {/* 파일 확장자 */}
              {FileExtComponent}
              {/* 부가기능 */}
              {attachFunction}
              {/* 제약사항 */}
              {attachRestrict}
              {/* 첨부파일 제목 */}
              {attachSubject}
            </div>
          </div>
        );

        const inner = {
          key: attachInfo.attachInfoNo,
          value: attachInfo.attachInfoNo,
          text: renderTitle,
        };

        // 공개인 템플릿만 첨부파일 목록에 추가
        if (attachInfo.isPublic === 1) {
          attachOptions.push(inner);
        }

        // 현재 템플릿의 첨부파일을 목록에 추가
        if (
          attachInfo.attachInfoNo === templateInfo.attachInfoNo &&
          attachOptions.indexOf(inner) < 0
        ) {
          attachOptions.push(inner);
        }
      }
    }

    //첨부 없음 리스트 추가
    attachOptions.push({
      key: 0,
      value: 0,
      text: (
        <div className={cx("attach-input")}>
          <div
            className={cx(
              "render-title",
              "input-text-indent",
              "color-black",
              "bold"
            )}
          >
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_17",
                defaultMessage: "첨부 없음",
              })
            )}
          </div>
        </div>
      ),
    });

    // 훈련 유형
    const ExamTypeSelect = (
      <ReduxFormMaterialSelect
        disabled={!!!serviceTemplateNo && isAuth !== 2}
        required
        name="examType"
        className={cx("exam-type-list list-target", "input-flex", "input-area")}
        fullWidth
        menuList={examTypeList}
        checkType={101}
        validate={["required"]}
      />
    );

    // 템플릿 유형
    const ExamTypeDropdown = ExamTypeSelect;

    // 메일 제목 본문에 대상자 치환 정보
    const InfoComponent = (
      <div className={cx("mail-info-area")}>
        <div className={cx("mail-info-title")}>
          {defineMessages(
            formatMessage({
              id: "ExamTemplateEdit_58",
              defaultMessage: "대상별 정보 입력",
            })
          )}
        </div>
        <div className={cx("ml-7")}>
          <div className={cx("mb-5")}>
            <div>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_59",
                  defaultMessage:
                    "제목과 본문에 개별 대상자의 정보를 입력해서 메일을 발송 할 수 있습니다.",
                })
              )}
            </div>
            <div>
              {"ex> '${TARGET_NAME}$'" +
                defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_60",
                    defaultMessage: "님 안녕하세요",
                  })
                )}
            </div>
            <div className={cx("ml-27")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_61",
                  defaultMessage: "-> 김성희님 안녕하세요.",
                })
              )}
            </div>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "ModalTargetExcelUpload_2",
                  defaultMessage: "이름",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_NAME}$"}
            </span>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "ModalTargetExcelUpload_3",
                  defaultMessage: "이메일",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_EMAIL}$"}
            </span>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "PhishingTemplateEditModal_34",
                  defaultMessage: "아이디",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_ID}$"}
            </span>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "ModalTargetExcelUpload_4",
                  defaultMessage: "연락처",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_PHONE}$"}
            </span>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "ModalTargetExcelUpload_5",
                  defaultMessage: "소속",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_DIVISION}$"}
            </span>
          </div>
          <div>
            <span className={cx("info-inner-title")}>
              {defineMessages(
                formatMessage({
                  id: "ModalTargetExcelUpload_6",
                  defaultMessage: "직급",
                })
              )}
            </span>
            <span className={cx("info-inner-content")}>
              {"${TARGET_POSITION}$"}
            </span>
          </div>
        </div>
        <div className={cx("mt-10")}>
          <div className={cx("mail-info-title")}>
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_67",
                defaultMessage: "링크 첨부 다운로드 버튼 위치",
              })
            )}
          </div>
          <b>{"${LINK_TEXT}$"}</b>
          <div className={cx("ml-7")}>
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_68",
                defaultMessage:
                  "link_text를 입력 하여 메일 본문에 원하는 위치에 '다운로드 버튼'을 등록 할 수 있습니다. (단 첨부 유형이 링크 첨부)",
              })
            )}
          </div>
        </div>
      </div>
    );

    // 첨부파일 확장자 체크
    const fileExtMsg = checkFileExt();

    return (
      <div className={cx("template-edit-box")}>
        {onProgress && (
          <div className={cx("Loading")}>
            <Loading content={"Loading..."} />
          </div>
        )}
        <div className={cx("template-edit-section")}>
          <div className={cx("input-title")}>
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_8",
                defaultMessage: "템플릿",
              })
            )}
          </div>
          <span className={cx("materialTextField-title")}>
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_9",
                defaultMessage: "템플릿명",
              })
            )}
          </span>
          <ReduxFormMaterialTextField
            disabled={!!!serviceTemplateNo && isAuth !== 2}
            required
            fullWidth
            className={cx("input-area")}
            name="templateName"
            checkType={101}
            validate={["required", "templateName"]}
          />

          {/* 공개여부 */}
          {!!!serviceTemplateNo && isAuth === 2 && (
            <div className={cx("input-button", "input-gap-top")}>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_32",
                    defaultMessage: "공개 여부",
                  })
                )}
              </span>
              <div className={cx("input-button-comm")}>
                <div className={cx("button-exam")}>
                  <Button
                    onClick={() =>
                      this.onToggleSelected({
                        name: "templatePublic",
                        value: 1,
                      })
                    }
                    active={templatePublic === 1}
                  >
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: "ExamTemplateEdit_34",
                          defaultMessage: "공개",
                        })
                      )}
                      <i className={cx("input-button-check")} />
                    </span>
                  </Button>
                </div>
                <div className={cx("button-exam")}>
                  <Button
                    onClick={() =>
                      this.onToggleSelected({
                        name: "templatePublic",
                        value: 0,
                      })
                    }
                    active={templatePublic === 0}
                  >
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: "ExamTemplateEdit_33",
                          defaultMessage: "비공개",
                        })
                      )}
                      <i className={cx("input-button-check")} />
                    </span>
                  </Button>
                </div>
                <ReduxFormHiddenRecord
                  name="templatePublic"
                  validate={["required"]}
                  valuePass={templatePublic}
                />
              </div>
            </div>
          )}
        </div>

        {/* 템플릿 유형 */}
        <div className={cx("template-edit-section")}>
          <div className={cx("input-button")}>
            <div className={cx("input-title")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_27",
                  defaultMessage: "템플릿 유형",
                })
              )}
            </div>
            <span className={cx("materialTextField-title")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_28",
                  defaultMessage: "훈련 유형",
                })
              )}
            </span>
            <Popup
              className="max-250"
              position="left center"
              trigger={
                <div className={cx("input-button-comm", "input-button-exam")}>
                  <div className={cx("button-exam-left")}>
                    <Button
                      className={cx("input-button-exam-in")}
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "examType", value: 1 })
                      }
                      active={this.state.examType === 1 || examType === 1}
                    >
                      <div className={cx("button-exam-left-in")}>
                        <div
                          className={cx(
                            "examAttach",
                            attachValue &&
                              attachValue.attachExamType === 1 &&
                              "examAttach-selected"
                          )}
                        >
                          <i className={cx("input-button-check")} />
                          <i className={cx("examAttach-icon examWarning")} />
                          <div className={cx("exam-title")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_72",
                                defaultMessage: "경고 안내",
                              })
                            )}
                          </div>
                          <div className={cx("exam-subtitle")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_73",
                                defaultMessage: "훈련임을 안내",
                              })
                            )}
                          </div>
                          <span className={cx("exam-content")}>
                            {ReactHtmlParser(
                              defineMessages(
                                formatMessage({
                                  id: "ExamTemplateEdit_74",
                                  defaultMessage:
                                    "PC 잠금 화면이 실행되어 대상자에게 경고 문구를 안내해주는 훈련입니다.",
                                })
                              )
                            )}
                          </span>
                        </div>
                        <div
                          className={cx(
                            "examAttach",
                            attachValue &&
                              attachValue.attachExamType === 2 &&
                              "examAttach-selected"
                          )}
                        >
                          <i className={cx("input-button-check")} />
                          <i className={cx("examAttach-icon examFile")} />
                          <div className={cx("exam-title")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_75",
                                defaultMessage: "모의 악성파일",
                              })
                            )}
                          </div>
                          <div className={cx("exam-subtitle")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_76",
                                defaultMessage: "PC 잠금",
                              })
                            )}
                          </div>
                          <span className={cx("exam-content")}>
                            {ReactHtmlParser(
                              defineMessages(
                                formatMessage({
                                  id: "ExamTemplateEdit_77",
                                  defaultMessage:
                                    "PC 잠금 화면이 실행되어 대상자가 PC를 사용할 수 없게 되는 훈련입니다.",
                                })
                              )
                            )}
                          </span>
                        </div>
                        <div
                          className={cx(
                            "examAttach",
                            attachValue &&
                              attachValue.attachExamType === 3 &&
                              "examAttach-selected examCheat"
                          )}
                        >
                          <i className={cx("input-button-check")} />
                          <i className={cx("examAttach-icon examCheat")} />
                          <div className={cx("exam-title")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_78",
                                defaultMessage: "실태 조사",
                              })
                            )}
                          </div>
                          <div className={cx("exam-subtitle")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_79",
                                defaultMessage: "훈련임을 숨김",
                              })
                            )}
                          </div>
                          <span className={cx("exam-content")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_80",
                                defaultMessage:
                                  "첨부파일의 형태로 실행되어 대상자가 훈련임을 알 수 없는 훈련입니다.",
                              })
                            )}
                            <br />
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_81",
                                defaultMessage: "ex) excel이 실행됨",
                              })
                            )}
                          </span>
                        </div>
                      </div>
                    </Button>
                  </div>
                  <div className={cx("button-exam-right")}>
                    <Button
                      className={cx("input-button-exam-in")}
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "examType", value: 4 })
                      }
                      active={this.state.examType === 4 || examType === 4}
                    >
                      <div className={cx("button-exam-right-in")}>
                        <div
                          className={cx(
                            "examAttach",
                            examType && examType === 4 && "examAttach-selected"
                          )}
                        >
                          <i className={cx("input-button-check")} />
                          <i className={cx("examAttach-icon examPhishing")} />
                          <div className={cx("exam-title")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_82",
                                defaultMessage: "피싱 유도",
                              })
                            )}
                          </div>
                          <div className={cx("exam-subtitle")}>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_83",
                                defaultMessage: "피싱 페이지",
                              })
                            )}
                          </div>
                          <span
                            className={cx("exam-content", "exam-content-exc")}
                          >
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_84",
                                defaultMessage:
                                  "피싱 유도 링크가 메일에 삽입되어 대상자가 정보를 입력하는 형태의 훈련입니다.",
                              })
                            )}
                          </span>
                        </div>
                      </div>
                    </Button>
                  </div>
                  <ReduxFormHiddenRecord
                    name="examType"
                    validate={["templateType"]}
                    valuePass={examType}
                  />
                </div>
              }
              content={defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_88",
                  defaultMessage:
                    "첨부파일 정보에서 가져온 파일의 '훈련 유형'이 선택 됩니다.",
                })
              )}
            />
          </div>
        </div>

        {/* 첨부파일 정보 - 경고 안내, 모의 악성파일, 실태 조사일때만 나옴 */}
        {(examType === 1 || examType === 2 || examType === 3) && (
          <div className={cx("template-edit-section template-edit-attach")}>
            <div className={cx("input-title")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_15",
                  defaultMessage: "첨부파일 정보",
                })
              )}
            </div>
            <span className={cx("materialTextField-title")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_71",
                  defaultMessage: "첨부 파일 가져오기",
                })
              )}
            </span>
            <div className={cx("list-list attach-list-select")}>
              <div className={cx("list-dropdown")}>
                <Popup
                  position="left center"
                  trigger={
                    <div
                      className={cx(
                        "flex-row-center",
                        "input-select",
                        "input-select-attach"
                      )}
                    >
                      <ReduxFormMaterialSelect
                        disabled={!!!serviceTemplateNo && isAuth !== 2}
                        required
                        name="attachInfoNo"
                        className={cx(
                          "list-template",
                          "input-gap",
                          "flex-column",
                          "input-area"
                        )}
                        fullWidth
                        menuList={attachOptions}
                        checkType={101}
                        validate={["templateRequired"]}
                        onChange={(e, value) => {
                          onChangeAttachInfoNo(value);
                        }}
                      />
                    </div>
                  }
                  content={
                    <div className={cx("attach-popup")}>
                      <div className={cx("func")}>
                        <div className={cx("bold")}>
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachList_5",
                              defaultMessage: "부가 기능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachFunction").indexOf("PG") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachFunc_1",
                              defaultMessage:
                                "PG(PC Gather) - PC 정보 수집 기능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachFunction").indexOf("LG") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachFunc_2",
                              defaultMessage:
                                "LG(LeakFile Gather) - PC의 파일 정보 수집 기능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachFunction").indexOf("PL") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachFunc_3",
                              defaultMessage:
                                "PL(PC Lock) - PC 잠금(모의악성) 기능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachFunction").indexOf("VS") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachFunc_4",
                              defaultMessage:
                                "VS(Vaccine Step) - 백신 단계 기능",
                            })
                          )}
                        </div>
                      </div>
                      <div className={cx("restrict")}>
                        <div className={cx("bold mt-10")}>
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachList_6",
                              defaultMesssage: "제약 사항",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("UAC") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_1",
                              defaultMessage:
                                "UAC(User Account Control) - Windows 사용자 계정 컨트롤 탐지 가능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("SS") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_2",
                              defaultMessage:
                                "SS(Smart Screen) - Windows 스마트 스크린에 탐지 가능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("SF") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_3",
                              defaultMessage:
                                "SF(Spam Filter) - 메일 스팸 필터에 탐지 가능",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("VD") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_4",
                              defaultMessage:
                                "VD(Vaccine Detect) - 백신 탐지 가능함(V3, 알약···)",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("LC") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_5",
                              defaultMessage:
                                "LC(Link Click) - 문서 안에 링크를 클릭해야 감염 처리",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("UC") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_6",
                              defaultMessage:
                                "UC(User Control) - 사용자의 동의가 필요함",
                            })
                          )}
                        </div>
                        <div
                          className={cx({
                            brand:
                              aData &&
                              aData.get("attachRestrict").indexOf("DW") > -1,
                          })}
                        >
                          {defineMessages(
                            formatMessage({
                              id: "ExamAttachRestrict_7",
                              defaultMessage:
                                "DW(Download Warning) - 메일에서 파일 다운로드시 경고 발생",
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  }
                />
              </div>
              {attachInfoNo > 0 && (
                <Popup
                  className="max-250"
                  trigger={
                    <div className={cx("actionImage")}>
                      {defineMessages(
                        formatMessage({
                          id: "ExamTemplateEdit_89",
                          defaultMessage: "실행 결과 이미지",
                        })
                      )}
                    </div>
                  }
                  content={
                    <Image
                      src={
                        aData
                          ? "/fdata/attachFile/" +
                            attachValue.attachInfoNo +
                            "/" +
                            attachValue.actionImage
                          : null
                      }
                    />
                  }
                />
              )}
            </div>
            {attachValue ? (
              <div className={cx("input-button", "input-gap")}>
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "ExamTemplateEdit_40",
                      defaultMessage: "다운로드 유형",
                    })
                  )}
                </span>
                <div className={cx("input-button-comm")}>
                  <div className={cx("button-exam")}>
                    <Button
                      className={cx("input-gap")}
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "linkAttach", value: 2 })
                      }
                      active={this.state.linkAttach === 2 || linkAttach === 2}
                    >
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: "ExamTemplateEdit_42",
                            defaultMessage:
                              "링크 첨부 (메일 본문에 다운로드 버튼)",
                          })
                        )}
                        <i className={cx("input-button-check")} />
                      </span>
                    </Button>
                  </div>
                  <div className={cx("button-exam")}>
                    <Button
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "linkAttach", value: 1 })
                      }
                      active={this.state.linkAttach === 1 || linkAttach === 1}
                    >
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: "ExamTemplateEdit_41",
                            defaultMessage: "첨부 파일로 다운로드",
                          })
                        )}
                        <i className={cx("input-button-check")} />
                      </span>
                    </Button>
                  </div>
                  <ReduxFormHiddenRecord
                    name="linkAttach"
                    validate={["templateType"]}
                    valuePass={linkAttach}
                  />
                </div>
              </div>
            ) : null}
            {attachValue ? (
              <div className={cx("input-button", "input-gap")}>
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "ExamTemplateList_8",
                      defaultMessage: "첨부 유형",
                    })
                  )}
                </span>
                <div className={cx("input-button-comm")}>
                  {attachValue.fileExt === "lnk" ? null : (
                    <div className={cx("button-exam")}>
                      <Button
                        disabled={!!!serviceTemplateNo && isAuth !== 2}
                        onClick={() =>
                          this.onToggleSelected({
                            name: "attachType",
                            value: 1,
                          })
                        }
                        active={this.state.attachType === 1 || attachType === 1}
                      >
                        <span>
                          {defineMessages(
                            formatMessage({
                              id: "ExamTemplateEdit_18",
                              defaultMessage: "원본",
                            })
                          )}
                          <i className={cx("input-button-check")} />
                        </span>
                      </Button>
                    </div>
                  )}
                  <div className={cx("button-exam")}>
                    <Button
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "attachType", value: 2 })
                      }
                      active={this.state.attachType === 2 || attachType === 2}
                    >
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: "ExamTemplateEdit_19",
                            defaultMessage: "압축 파일",
                          })
                        )}
                        <i className={cx("input-button-check")} />
                      </span>
                    </Button>
                  </div>
                  <div className={cx("button-exam")}>
                    <Button
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      onClick={() =>
                        this.onToggleSelected({ name: "attachType", value: 3 })
                      }
                      active={this.state.attachType === 3 || attachType === 3}
                    >
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: "ExamTemplateEdit_20",
                            defaultMessage: "비밀번호 설정된 압축 파일",
                          })
                        )}
                        <i className={cx("input-button-check")} />
                      </span>
                    </Button>
                  </div>
                  <ReduxFormHiddenRecord
                    name="attachType"
                    validate={["templateType"]}
                    valuePass={attachType}
                  />
                </div>
              </div>
            ) : null}

            {/* 첨부파일명 / 압축 파일 종류 */}
            {attachValue && attachInfoNo !== 0 && attachType > 1 && (
              <div className={cx("content-flex", "input-gap")}>
                <div
                  className={cx(
                    "content-flex-inner",
                    "flex-gap-left",
                    "input-flex-2"
                  )}
                >
                  <span className={cx("materialTextField-title")}>
                    {defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_21",
                        defaultMessage:
                          "압축파일명 (메일에 첨부되는 압축파일의 파일 이름을 지정할 수 있습니다.)",
                      })
                    )}
                  </span>
                  <ReduxFormMaterialTextField
                    disabled={!!!serviceTemplateNo && isAuth !== 2}
                    required
                    fullWidth
                    name="attachCompressName"
                    className={cx("input-area", "input-text-indent")}
                    checkType={101}
                    validate={["required", "windowsFileName"]}
                    error={!!this.warnAttachCompress}
                    errorText={this.warnAttachCompress}
                    onChange={onChangeAttachCompress}
                  />
                </div>

                {/* 압축 비밀번혼 */}
                {attachType > 2 && (
                  <div className={cx("content-flex-inner", "flex-gap-left")}>
                    <span className={cx("materialTextField-title")}>
                      {defineMessages(
                        formatMessage({
                          id: "ExamTemplateEdit_24",
                          defaultMessage: "압축 비밀번호",
                        })
                      )}
                    </span>
                    <ReduxFormMaterialTextField
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      required
                      fullWidth
                      name="attachCompressPasswd"
                      className={cx("input-flex", "input-gap", "input-area")}
                      checkType={101}
                      validate={["required", "range50", "templatePW"]}
                    />
                  </div>
                )}
                <div className={cx("content-flex-inner", "flex-gap-left")}>
                  <span className={cx("materialTextField-title")}>
                    {defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_22",
                        defaultMessage: "압축 파일 종류",
                      })
                    )}
                  </span>
                  <div className={cx("flex-row-center", "input-select")}>
                    <ReduxFormMaterialSelect
                      disabled={!!!serviceTemplateNo && isAuth !== 2}
                      required
                      name="attachCompress"
                      className={cx(
                        "list-target",
                        "input-flex",
                        "input-gap",
                        "input-area",
                        "input-text-indent"
                      )}
                      fullWidth
                      menuList={[
                        { key: 1, value: 1, text: "Zip" },
                        {
                          key: 2,
                          value: 2,
                          text: defineMessages(
                            formatMessage({
                              id: "ExamTemplateEdit_35",
                              defaultMessage: "7z (원본파일 숨김)",
                            })
                          ),
                        },
                      ]}
                      checkType={101}
                      validate={[
                        "required",
                        "examTemplateAttachFileCompressTypeMin",
                        "examTemplateAttachFileCompressTypeMax",
                      ]}
                      onChange={onChangeAttachCompress}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* 원본파일명 */}
            {attachValue && attachType > 0 && (
              <div>
                <span className={cx("materialTextField-title")}>
                  {attachTypeLable}
                </span>
                <div className={cx("flex-row-flex-start", "input-select")}>
                  <ReduxFormMaterialTextField
                    disabled={!!!serviceTemplateNo && isAuth !== 2}
                    required
                    fullWidth
                    refPass={(ref) => (this.coreFileRef = ref)}
                    name="attachName"
                    className={cx(
                      "input-core-name",
                      "input-flex",
                      "input-area"
                    )}
                    checkType={101}
                    validate={[
                      "required",
                      "windowsFileName",
                      // fileExtValidation,
                      "attachName",
                    ]}
                    error={!!fileExtMsg}
                    errorText={fileExtMsg}
                  />
                </div>
              </div>
            )}
            {AttachInfo}
          </div>
        )}

        {/* 피싱 유도 - 피싱 타입 설정 */}
        {/* 추후에 피싱 테이블을 만들어서 피싱 리스트를 DB에서 조회해야 한다. */}
        {examType === 4 && (
          <div className={cx("template-edit-section")}>
            <div className={cx("input-title")}>
              {defineMessages(
                formatMessage({
                  id: "ExamTemplateEdit_63",
                  defaultMessage: "피싱 유도 설정",
                })
              )}
            </div>
            <div
              className={cx(
                "flex-row-flex-start",
                "input-select",
                "input-area-mt"
              )}
            >
              <ReduxFormMaterialSelect
                disabled={!!!serviceTemplateNo && isAuth !== 2}
                required
                // label={defineMessages(formatMessage({ id: 'ExamTemplateEdit_64', defaultMessage: '피싱 페이지 타입' }))}
                name="phishingNo"
                className={cx(
                  "input-area",
                  "input-text-indent",
                  "select-input"
                )}
                fullWidth
                // nonExistValue={this.state.phishingName}
                validate={["required"]}
                menuList={this.state.phishingList}
                checkType={101}
              />
            </div>
          </div>
        )}
        <div className={cx("template-edit-section")}>
          <div className={cx("input-title")}>
            {defineMessages(
              formatMessage({
                id: "ExamTemplateEdit_10",
                defaultMessage: "발송 정보",
              })
            )}
          </div>
          <div className={cx("content-flex")}>
            <div className={cx("content-flex-small", "flex-gap-left")}>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_11",
                    defaultMessage: "발송자",
                  })
                )}
              </span>
              <div className={cx("flex-row-flex-start")}>
                <ReduxFormMaterialTextField
                  disabled={!!!serviceTemplateNo && isAuth !== 2}
                  required
                  fullWidth
                  name="senderName"
                  className={cx("input-flex", "input-area")}
                  checkType={101}
                  validate={["required", "senderName"]}
                />
              </div>
            </div>
            <div className={cx("content-flex-inner", "flex-gap-left")}>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_12",
                    defaultMessage: "발송 이메일",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                disabled={!!!serviceTemplateNo && isAuth !== 2}
                required
                fullWidth
                name="senderEmail"
                className={cx("input-flex", "input-area")}
                checkType={101}
                validate={["required", "email"]}
              />
            </div>
            <div className={cx("content-flex-inner", "flex-gap-left")}>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_98",
                    defaultMessage: "봉투 발송 이메일",
                  })
                )}
              </span>
              <ReduxFormMaterialTextField
                disabled={!!!serviceTemplateNo && isAuth !== 2}
                required
                fullWidth
                name="envelopSenderEmail"
                className={cx("input-flex", "input-area")}
                checkType={101}
                validate={["required", "email"]}
              />
              <div className="input-flex font-size-12 brand mt-4 ml-4">
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_47",
                    defaultMessage:
                      "*도메인이 존재하지 않으면 메일 발송이 실패 할 수 있습니다.",
                  })
                )}
              </div>
            </div>
          </div>
        </div>
        <Popup
          position="left center"
          trigger={
            <div className={cx("template-edit-section")}>
              <div className={cx("input-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_13",
                    defaultMessage: "메일 내용",
                  })
                )}
              </div>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_14",
                    defaultMessage: "메일 제목",
                  })
                )}
              </span>
              <div className={cx("flex-row-flex-start")}>
                <ReduxFormMaterialTextField
                  disabled={!!!serviceTemplateNo && isAuth !== 2}
                  fullWidth
                  required
                  // label={defineMessages(formatMessage({ id: 'ExamTemplateEdit_14', defaultMessage: '메일 제목' }))}
                  name="subject"
                  className={cx("input-gap", "input-area")}
                  checkType={101}
                  validate={["required", "range5000"]}
                />
              </div>
              <span className={cx("materialTextField-title")}>
                {defineMessages(
                  formatMessage({
                    id: "ExamTemplateEdit_48",
                    defaultMessage: "메일 본문",
                  })
                )}
              </span>
              <ReduxFormHiddenRecord name="body" valuePass={convertHtml} />
              {examType !== 4 && (
                // <Editor
                //   readOnly={!!!serviceTemplateNo && isAuth !== 2}
                //   editorState={editorState}
                //   wrapperClassName="editor-warpper mt-5"
                //   toolbarClassName="editor-toolbar"
                //   editorClassName="editor-content"
                //   onEditorStateChange={handleOnEditorStateChange}
                //   localization={{
                //     locale: localStorage.getItem('language') === 'ko' ? 'ko' : 'en'
                //   }}
                //   toolbar={this.toolbarOptions}
                //   handlePastedText={() => this.handlePastedText('editor')}
                // // toolbarCustomButtons={[<CustomOption />]}
                // />
                // <ReactSummernote
                //   id="editor-body"
                //   className="summernote-editor"
                //   value={this.state.convertHtml}
                //   options={this.summernoteOptions}
                //   onChange={(contents) => this.onChangeEditor(contents, 'convertHtml')}
                //   onImageUpload={this.onImageUpload}
                //   disabled={!serviceTemplateNo && isAuth !== 2}
                // />
                <CustomEditor
                  className={cx(
                    "summernote-editor",
                    bodyDisable ? "disable-toolbar" : ""
                  )}
                  value={this.state.convertHtml}
                  options={this.summernoteOptions}
                  disabled={!serviceTemplateNo && isAuth !== 2}
                  onChange={(contents) =>
                    this.onChangeEditor(contents, "convertHtml")
                  }
                  onImageUpload={this.onImageUploadEditor}
                  onFocus={() => this.onFocusEditor("convertHtml")}
                />
              )}

              {/* 템플릿관리 - 피싱템플릿 본문보기 */}
              <div
                className={cx(
                  "phishingImg-wrap input-area",
                  !!!serviceTemplateNo && isAuth !== 2 && "disabled"
                )}
              >
                <iframe
                  id="phishing-body-iframe"
                  className={cx(
                    "phishing-body-iframe",
                    examType === 4 ? "on" : "off"
                  )}
                  frameBorder="0"
                />
              </div>
            </div>
          }
          content={InfoComponent}
        />

        {
          // 첨부가 경고 안내, 모의 악성파일일때
          ((attachValue &&
            (attachValue.attachExamType === 1 ||
              attachValue.attachExamType === 2)) ||
            // 피싱 훈련 일때
            examType === 4) && (
            <div className={cx("template-edit-section", "attach-screen-wrap")}>
              <div className={cx("input-title")}>
                {examType !== 4
                  ? defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_49",
                        defaultMessage: "PC 잠금 화면 설정",
                      })
                    )
                  : phishingScreenEnable === 1 &&
                    defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_92",
                        defaultMessage: "피싱 결과 화면 내용",
                      })
                    )}
              </div>
              {/* 결과 화면의 훈련 화면으로 이동 여부 */}
              {/*  피싱 훈련 일때 */}
              {/* {examType === 4 && (
                <div className={cx('input-button input-gap')}>
                  <span className={cx('materialTextField-title')}>
                    {defineMessages(
                      formatMessage({ id: 'ExamTemplateEdit_93', defaultMessage: '훈련 안내 화면 사용 여부' })
                    )}
                  </span>
                  <div className={cx('input-button-comm', 'input-button-eqline')}>
                    <div className={cx('button-exam')}>
                      <Button
                        onClick={() => this.onToggleSelected({ name: 'screenEnable', value: 1 })}
                        active={screenEnable === 1}>
                        <span>
                          {defineMessages(formatMessage({ id: 'ExamTemplateEdit_94', defaultMessage: '사용' }))}
                          <i className={cx('input-button-check')} />
                        </span>
                      </Button>
                    </div>
                    <div className={cx('button-exam')}>
                      <Button
                        onClick={() => this.onToggleSelected({ name: 'screenEnable', value: 0 })}
                        active={screenEnable === 0}>
                        <span>
                          {defineMessages(formatMessage({ id: 'ExamTemplateEdit_95', defaultMessage: '미사용' }))}
                          <i className={cx('input-button-check')} />
                        </span>
                      </Button>
                    </div>
                    <ReduxFormHiddenRecord name="screenEnable" validate={['required']} valuePass={screenEnable} />
                  </div>
                </div>
              )} */}

              {attachValue &&
                attachValue.attachExamType === 2 &&
                examType !== 4 && (
                  <div className={cx("input-button input-gap")}>
                    <span className={cx("materialTextField-title")}>
                      {defineMessages(
                        formatMessage({
                          id: "ExamTemplateEdit_90",
                          defaultMessage: "잠금 화면 타입",
                        })
                      )}
                    </span>
                    <div
                      className={cx("input-button-comm", "input-button-eqline")}
                    >
                      <div className={cx("button-exam")}>
                        <Button
                          onClick={() =>
                            this.onToggleSelected({
                              name: "attachScreenType",
                              value: 1,
                            })
                          }
                          active={attachScreenType === 1}
                        >
                          <span>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_53",
                                defaultMessage: "닫기 버튼 클릭",
                              })
                            )}
                            <i className={cx("input-button-check")} />
                          </span>
                        </Button>
                      </div>
                      <div className={cx("button-exam")}>
                        <Button
                          onClick={() =>
                            this.onToggleSelected({
                              name: "attachScreenType",
                              value: 2,
                            })
                          }
                          active={attachScreenType === 2}
                        >
                          <span>
                            {defineMessages(
                              formatMessage({
                                id: "ExamTemplateEdit_52",
                                defaultMessage: "비밀번호 입력",
                              })
                            )}
                            <i className={cx("input-button-check")} />
                          </span>
                        </Button>
                      </div>
                      <ReduxFormHiddenRecord
                        name="attachScreenType"
                        validate={["required"]}
                        valuePass={attachScreenType}
                      />
                    </div>
                  </div>
                )}

              {examType !== 4 &&
              attachValue &&
              attachValue.attachExamType === 2 &&
              (attachValue.attachCategory === 1 ||
                attachValue.attachCategory === 2) &&
              attachScreenType === 2 ? (
                <div
                  className={cx("template-edit-section", "attach-screen-wrap")}
                >
                  <span className={cx("materialTextField-title")}>
                    {defineMessages(
                      formatMessage({
                        id: "ExamTemplateEdit_54",
                        defaultMessage: "PC잠금 해제 비밀번호",
                      })
                    )}
                  </span>
                  <ReduxFormMaterialTextField
                    disabled={!!!serviceTemplateNo && isAuth !== 2}
                    required
                    fullWidth
                    className={cx("input-gap", "input-area")}
                    name="attachScreenPassword"
                    validate={["required"]}
                    checkType={101}
                  />
                </div>
              ) : null}

              {examType !== 4 && (
                <span className={cx("materialTextField-title")}>
                  {defineMessages(
                    formatMessage({
                      id: "ExamTemplateEdit_57",
                      defaultMessage: "PC 잠금 화면 내용",
                    })
                  )}
                </span>
              )}
              <ReduxFormHiddenRecord
                name="attachScreenContent"
                valuePass={screenHtml}
              />
              {examType !== 4 && (
                // <Editor
                //   readOnly={!!!serviceTemplateNo && isAuth !== 2}
                //   editorState={screenState}
                //   wrapperClassName="editor-warpper mt-5"
                //   toolbarClassName="editor-toolbar"
                //   editorClassName="editor-content"
                //   onEditorStateChange={handleOnScreenEditorStateChange}
                //   localization={{
                //     locale: localStorage.getItem('language') === 'ko' ? 'ko' : 'en'
                //   }}
                //   toolbar={this.toolbarOptions}
                //   handlePastedText={() => this.handlePastedText('screen')}
                // />
                // <ReactSummernote
                //   id="editor-result"
                //   className="summernote-editor"
                //   value={this.state.screenHtml}
                //   options={this.summernoteOptions}
                //   onChange={(contents) => this.onChangeEditor(contents, 'screenHtml')}
                //   onImageUpload={this.onImageUpload}
                //   disabled={!serviceTemplateNo && isAuth !== 2}
                // />
                <CustomEditor
                  className={cx(
                    "summernote-editor",
                    resultDisable ? "disable-toolbar" : ""
                  )}
                  value={this.state.screenHtml}
                  options={this.summernoteOptions}
                  disabled={!serviceTemplateNo && isAuth !== 2}
                  onChange={(contents) =>
                    this.onChangeEditor(contents, "screenHtml")
                  }
                  onImageUpload={this.onImageUploadEditor}
                  onFocus={() => this.onFocusEditor("screenHtml")}
                />
              )}
              <div className="phishingImg-wrap input-area">
                <iframe
                  id="phishing-result-iframe"
                  className={cx(
                    "phishing-result-iframe",
                    phishingScreenEnable === 1 && examType === 4 ? "on" : "off"
                  )}
                  frameBorder="0"
                />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

ExamTemplateEdit.propTypes = {
  templateInfo: PropTypes.object,
  attachData: PropTypes.object,
};

export default injectIntl(ExamTemplateEdit);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateEdit.js